
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { Playground, Props } from 'docz'
import { State } from 'react-powerplug'
import FormFieldText from './form-field-text'


const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h1 {...{
      "id": "formfieldtext"
    }}>{`FormFieldText`}</h1>
    <p><strong parentName="p">{`SUBCATEGORY:`}</strong>{` Forms`}</p>
    <hr />
    <h2 {...{
      "id": "text-field"
    }}>{`Text field`}</h2>
    <h3 {...{
      "id": "description"
    }}>{`Description`}</h3>
    <p>{`For a single line of text.`}</p>
    <Playground __position={1} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"text\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='text' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldText" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Placeholder`}</strong></p>
    <Playground __position={2} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"text-placeholder\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      placeholder=\"Text placeholder\"\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='text-placeholder' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} placeholder="Text placeholder" mdxType="FormFieldText" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Optional`}</strong></p>
    <Playground __position={3} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"text-optional\"\n      labelTag=\"Tag\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='text-optional' labelTag="Tag" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldText" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Helper`}</strong></p>
    <Playground __position={4} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"text-helper\"\n      helperText=\"Helper text\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='text-helper' helperText="Helper text" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldText" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Validation`}</strong></p>
    <Playground __position={5} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"validation\"\n      error=\"Notice\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='validation' error="Notice" labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldText" />}
  </State>
    </Playground>
    <p><strong parentName="p">{`Disabled`}</strong></p>
    <Playground __position={6} __code={'<FormFieldText\n  disabled\n  id=\"text-disabled\"\n  labelText=\"Label\"\n  maxLength={30}\n  value=\"Text value\"\n/>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <FormFieldText disabled id='text-disabled' labelText="Label" maxLength={30} value="Text value" mdxType="FormFieldText" />
    </Playground>
    <hr />
    <h2 {...{
      "id": "text-field-adjacent"
    }}>{`Text field (adjacent)`}</h2>
    <h3 {...{
      "id": "description-1"
    }}>{`Description`}</h3>
    <p>{`For a single line of text.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={8} __code={'<State initial={{ value: \'\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      adjacent\n      {...state}\n      id=\"text\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: ''
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText adjacent {...state} id='text' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} mdxType="FormFieldText" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "text-field-slim"
    }}>{`Text field (slim)`}</h2>
    <h3 {...{
      "id": "description-2"
    }}>{`Description`}</h3>
    <p>{`For a single line of text. Use where inputs are nested or constrained by layout.`}</p>
    <Playground __position={10} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      id=\"text-slim\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} id='text-slim' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldText" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "text-field-slim-adjacent"
    }}>{`Text field (slim, adjacent)`}</h2>
    <h3 {...{
      "id": "description-3"
    }}>{`Description`}</h3>
    <p>{`For a single line of text. Use where inputs are nested or constrained by layout.`}</p>
    <p><strong parentName="p">{`Avoid including `}<inlineCode parentName="strong">{`error`}</inlineCode>{`, `}<inlineCode parentName="strong">{`labelTag`}</inlineCode>{` and `}<inlineCode parentName="strong">{`helperText`}</inlineCode>{` props when using adjacent layout. Instead, use the standard layout.`}</strong></p>
    <Playground __position={12} __code={'<State initial={{ value: \'Text value\' }}>\n  {({ state, setState }) => (\n    <FormFieldText\n      {...state}\n      adjacent\n      id=\"text-adjacent-slim\"\n      labelText=\"Label\"\n      maxLength={30}\n      onChange={e => setState({ value: e.target.value })}\n      slim\n    />\n  )}\n</State>'} __scope={{
      props: this ? this.props : props,
      Playground,
      Props,
      State,
      FormFieldText
    }} mdxType="Playground">
  <State initial={{
        value: 'Text value'
      }} mdxType="State">
    {({
          state,
          setState
        }) => <FormFieldText {...state} adjacent id='text-adjacent-slim' labelText="Label" maxLength={30} onChange={e => setState({
          value: e.target.value
        })} slim mdxType="FormFieldText" />}
  </State>
    </Playground>
    <hr />
    <h2 {...{
      "id": "properties"
    }}>{`Properties`}</h2>
    <Props of={FormFieldText} mdxType="Props" />
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;